import { actionClass } from "@ane/legacy/lib/decorators/ReduxDecorators";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let BannerActions = class {
  addBanner(banner) {
    return banner;
  }
  removeBanner(name) {
    return name;
  }
  removeBannerWithPrefix(name) {
    return name;
  }
};
BannerActions = __decorateClass([
  actionClass()
], BannerActions);
const modalActions = new BannerActions();
export {
  BannerActions,
  modalActions as default
};
//# sourceMappingURL=BannerActions.js.map
